import React from "react";

import RankingCard from "../../../shared/cards/RankingCard";
import ScrollFixed from "../../../shared/common/ScrollFixed";
import DefaultWrapper from "../DefaultWrapper";

const CoursesRanking = () => {
	return (
		<DefaultWrapper
			title="Ranking de cursos más completados"
			columns="span 8"
		>
			<ScrollFixed height="500px">
				<RankingCard />
				<RankingCard />
				<RankingCard />
				<RankingCard />
				<RankingCard />
				<RankingCard />
				<RankingCard />
				<RankingCard />
				<RankingCard />
			</ScrollFixed>
		</DefaultWrapper>
	);
};

export default CoursesRanking;
